<template>
    <b-container>
        <b-row>
            <b-col cols="12">
                <b-table
                    responsive
                    outlined
                    striped
                    :items="theControlPoints"
                    :fields="fields"
                >
                    <template slot="description" slot-scope="{ item }">
                        {{ item.description | elipsis(12) }}
                    </template>
                    <template slot="latitude" slot-scope="{ item }">
                        {{ item.latitude | elipsis(5) }}
                    </template>
                    <template slot="longitude" slot-scope="{ item }">
                        {{ item.longitude | elipsis(5) }}
                    </template>
                    <template slot="actions" slot-scope="{ item }">
                        <b-btn variant="primary" size="sm" @click="up(item)" :disabled="item.order === 1"><i class="fa fa-arrow-up"></i></b-btn>
                        <b-btn variant="primary" size="sm" @click="down(item)" :disabled="item.order === controlPoints.length"><i class="fa fa-arrow-down"></i></b-btn>
                    </template>
                </b-table>
                <!-- <b-list-group>
                    <b-list-group-item>
                        <b-row>
                            <b-col>Nombre</b-col>
                            <b-col>Descripción</b-col>
                            <b-col>Latitud</b-col>
                            <b-col>Longitud</b-col>
                            <b-col>Orden</b-col>
                            <b-col>Acciones</b-col>
                        </b-row>
                    </b-list-group-item>
                    <b-list-group-item v-for="cp in controlPoints" :key="cp.id">
                        <b-row v-if="!cp.edit">
                            <b-col>{{ cp.name }}</b-col>
                            <b-col>{{ cp.description | elipsis(15) }}</b-col>
                            <b-col>{{ cp.latitude }}</b-col>
                            <b-col>{{ cp.longitude }}</b-col>
                            <b-col>{{ cp.order }}</b-col>
                            <b-col>
                                <b-btn variant="primary" size="sm" @click="edit(cp)" :disabled="inEdition"><i class="fa fa-pencil"></i></b-btn>
                                <b-btn variant="danger" size="sm"><i class="fa fa-trash"></i></b-btn>
                            </b-col>
                        </b-row>
                        <b-row v-else>
                            <b-col><app-form-text-input label="Nombre" v-model="selectedPoint.name"></app-form-text-input></b-col>
                            <b-col><app-form-text-input label="Descripción" v-model="selectedPoint.description"></app-form-text-input></b-col>
                            <b-col>
                                <b-btn variant="primary" size="sm" @click="save"><i class="fa fa-save"></i></b-btn>
                            </b-col>
                        </b-row>
                    </b-list-group-item>
                </b-list-group> -->
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import roundsRepository from '@repositories/rounds.repository';
export default {
    props: {
        controlPoints: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        selectedPoint: {
            id: '',
            name: '',
            description: ''
        },
        inEdition: false,
        fields: [
            {
                key: 'order',
                label: 'Orden'
            },
            {
                key: 'name',
                label: 'Nombre'
            },
            {
                key: 'description',
                label: 'Descripción'
            },
            {
                key: 'latitude',
                label: 'Latitud'
            },
            {
                key: 'longitude',
                label: 'Longitud'
            },            
            {
                key: 'actions',
                label: 'Acciones'
            },
        ]
    }),
    computed: {
        theControlPoints() {
            return this.controlPoints.sort((a, b) => a.order - b.order);
        }
    },
    methods: {
        edit(cp) {
            this.inEdition = true;
            const index = this.controlPoints.findIndex(item => item.id === cp.id);
            const newCp = {...cp, edit: true};
            this.controlPoints.splice(index, 1, newCp);
            this.selectedPoint = newCp;
        },
        save() {
            const index = this.controlPoints.findIndex(item => item.id === this.selectedPoint.id);

            const newCp = {...this.selectedPoint, edit: false};

            this.controlPoints.splice(index, 1, newCp);

            this.resetControlPoint();
        },
        resetControlPoint() {
            this.selectedPoint = {
                id: '',
                name: '',
                description: ''
            };
            this.inEdition = false;
        },
        async up(cp) {
            const currentOrder = cp.order;
            const prevOrder = currentOrder - 1;

            const currentIndex = this.controlPoints.findIndex(item => item.order === currentOrder);

            const current = {...this.controlPoints[currentIndex], order: prevOrder};
            const prev = {...this.controlPoints[currentIndex - 1], order: currentOrder};

            const data = await this.updateOrder(current, prev);
            
            if(data) {
                this.controlPoints.splice(currentIndex - 1, 2, current, prev);
            }

        }, 
        async down(cp) {

            const currentOrder = cp.order;
            const nextOrder = currentOrder + 1;

            const currentIndex = this.controlPoints.findIndex(item => item.order === currentOrder);

            const current = {...this.controlPoints[currentIndex], order: nextOrder};
            const next = {...this.controlPoints[currentIndex + 1], order: currentOrder};

            const data = await this.updateOrder(current, next);
            
            if(data) {
                this.controlPoints.splice(currentIndex, 2, next, current);
            }
        },
        async updateOrder(one, two) {
            const payload = {
                points: [
                    { controlPointId: one.id, order: one.order },
                    { controlPointId: two.id, order: two.order },
                ]
            };

            const rr = {...roundsRepository};

            const { data } = await rr.updateControlPointsOrder(payload).catch(error => toastr.error('Ocurrió un error al actualizar el orden'));

            return data;
        }
    }
}
</script>

